export default "__VITE_ASSET__COiqZAUa__"